import React from 'react'
import { Container, Box, Typography, IconButton } from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import CodingAuditTrail from '../components/mrd/MedicalCoding/CodingAuditTrail'

export const CodingAuditTrailPage = () => {
  const navigate = useNavigate()

  return (
    <Container maxWidth="xl">
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ mr: 2 }}>
          <ArrowBack />
        </IconButton>
        <Box>
          <Typography variant="h4" fontWeight={600}>
            Coding Audit Trail
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Complete audit log of all coding activities and changes
          </Typography>
        </Box>
      </Box>
      
      <CodingAuditTrail />
    </Container>
  )
}

